/**
 * Horizontal App
 */
import React from 'react';
import { useLocation, Navigate, Route, Routes } from 'react-router-dom';

// horizontal layout
import RctHorizontalLayout from 'Components/RctHorizontalLayout';

// modules
import Master from 'Routes/master';
import Sportsscience from 'Routes/sportsscience';
import Golf from 'Routes/golf';
import Travel from 'Routes/travelr';
import Contract from 'Routes/contract';
import Dashboard from 'Routes/dashboard';
import ParentDashboard from 'Routes/dashboard/parentdashboard';
import StudentDashboard from 'Routes/dashboard/studentdashboard';
import CommonDashboard from 'Routes/dashboard/commondashboard';

const getDefaultDashboardRoute = () => {
   const role = localStorage.getItem('user_role');
   const studentRole = localStorage.getItem('stdrole');

   if (role == 12) return 'parentdashboard';
   if (role == 14) return 'commondashboard';
   if (studentRole == 1) return 'studentdashboard';
   return 'dashboard';
};

const RctHorizontalApp = () => {
   const location = useLocation();
   const defaultDashboard = getDefaultDashboardRoute();

   // redirect "/" to role-based dashboard
   if (location.pathname === '/') {
      return <Navigate to={`/app/${defaultDashboard}`} replace />;
   }

   return (
      <RctHorizontalLayout>
         <Routes>
            {/* default redirect inside /app */}
            <Route index element={<Navigate to={defaultDashboard} replace />} />

            {/* Dashboards */}
            <Route path="dashboard/*" element={<Dashboard />} />
            <Route path="parentdashboard/*" element={<ParentDashboard />} />
            <Route path="studentdashboard/*" element={<StudentDashboard />} />
            <Route path="commondashboard/*" element={<CommonDashboard />} />

            {/* Other modules */}
            <Route path="master/*" element={<Master />} />
            <Route path="sportsscience/*" element={<Sportsscience />} />
            <Route path="golf/*" element={<Golf />} />
            <Route path="travel/*" element={<Travel />} />
            <Route path="contract/*" element={<Contract />} />

            {/* fallback */}
            <Route path="*" element={<Navigate to={defaultDashboard} replace />} />
         </Routes>
      </RctHorizontalLayout>
   );
};

export default RctHorizontalApp;
